import { ChangeDetectionStrategy, Component, output, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { StringComparisonEnum } from '@planning/types';
import { SelectItem } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';

@Component({
    selector: 'unified-ui-filter-string-comparison',
    standalone: true,
    imports: [SelectModule, FormsModule, InputTextModule],
    templateUrl: './filter-string-comparison.component.html',
    styleUrl: './filter-string-comparison.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterStringComparisonComponent {
    public readonly label = input.required<string>();
    public readonly comparisonOptions = input<SelectItem[]>([
    { label: 'None', value: StringComparisonEnum.None },
    { label: 'Equals', value: StringComparisonEnum.Equals },
    { label: 'Contains', value: StringComparisonEnum.Contains },
    { label: 'Start With', value: StringComparisonEnum.StartsWith },
    { label: 'Ends With', value: StringComparisonEnum.EndsWith }
]);
    public readonly comparisonType = input<string>(StringComparisonEnum.None);
    public readonly compareWith = input<string>('');

    protected readonly onChange = output<{
    comparisonType: StringComparisonEnum | string;
    compareWith: string;
}>();
}
